(ns common.opensearch.kanban-sort)

(def custom :sort-by/custom)
(def alphanumerical :sort-by/alphanumerical)
(def most-hits :sort-by/most-hits)
(def least-hits :sort-by/least-hits)
(def numeric :sort-by/numeric)
(def numeric-desc :sort-by/numeric-desc)
(def value-asc :sort-by/value-asc)
(def value-desc :sort-by/value-desc)

(def default-sort-mode custom)
(def default-column-sort-mode most-hits)
(def default-row-sort-mode most-hits)
(def default-card-sort-mode alphanumerical)

(def sort-modes-in-order
  [custom
   alphanumerical
   most-hits
   least-hits
   numeric
   numeric-desc
   value-asc
   value-desc])

(def sort-mode-enum
  (into [:enum] sort-modes-in-order))

(def sort-modes
  (set sort-modes-in-order))

(def column-sort-modes
  #{alphanumerical
    most-hits
    numeric
    numeric-desc
    value-desc})

(def row-sort-modes
  (conj column-sort-modes least-hits))

(def card-sort-modes
  #{alphanumerical
    value-desc})

(defn normalize-sort-mode
  [sort-mode]
  (if (contains? sort-modes sort-mode)
    sort-mode
    default-sort-mode))

(defn normalize-column-sort-mode
  [sort-mode]
  (if (contains? column-sort-modes sort-mode)
    sort-mode
    default-column-sort-mode))

(defn normalize-row-sort-mode
  [sort-mode]
  (if (contains? row-sort-modes sort-mode)
    sort-mode
    default-row-sort-mode))

(defn normalize-card-sort-mode
  [sort-mode]
  (if (contains? card-sort-modes sort-mode)
    sort-mode
    default-card-sort-mode))

(defn sort-mode?
  [sort-mode]
  (contains? sort-modes sort-mode))
